import { Store } from './types';

const STORE: Store = {
    app: {
        openOrders: null,
        notDispatchedOrders: null,
        products: null,
        tables: null,
        user: null,
        tableEvents: null,
        workingHours: null,
        selectedTableOrder: null,
        notifications: [],
        connection: null
    }
};

export default STORE;
